module.exports = __webpack_public_path__ + "398e3f1e96bf9c1b6ae61a55943a636c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_4.jpg
// module id = 1745
// module chunks = 5